import { useQuery } from "@tanstack/react-query";
import {
  unitSearch,
  UnitSearchParams,
} from "common/api/citajteo/dl_unit/citajteo_unit";
import { QUERY_KEYS } from "constant/react_query";
import {
  groupSearch,
  GroupSearchParams,
} from "common/api/citajteo/dl_group/citajteo_group";

type GroupSearchOptions = {
  initialSearch: boolean;
};

const INITIAL_GROUP_SEARCH_OPTIONS: GroupSearchOptions = {
  initialSearch: true,
};

export const useGroupSearchQuery = (
  searchParams?: GroupSearchParams,
  { initialSearch }: GroupSearchOptions = INITIAL_GROUP_SEARCH_OPTIONS
): { data: any; refetch: Function } => {
  const { data, refetch } = useQuery({
    queryKey: [QUERY_KEYS.CITAJTEO_DL_GROUP_SEARCH, searchParams],
    queryFn: async () => {
      const result = await groupSearch({ ...searchParams });
      return result;
    },
    enabled: initialSearch,
  });

  return { data, refetch };
};

export const useGroupSearch = (searchParams?: UnitSearchParams) => {
  const { data: groupResult } = useGroupSearchQuery(searchParams);

  const result =
    typeof groupResult !== "undefined" && groupResult !== ""
      ? groupResult
      : null;
  return result;
};
